import React from 'react';
import { Button, notification, Typography, Upload } from 'antd';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import Papa from 'papaparse';

import { IGpsPenaltyImport } from '@services/penalty';
import { Download, Import } from 'lucide-react';

const { Dragger } = Upload;
const { Text } = Typography;

interface IProps {
  onParsed: (data: IGpsPenaltyImport[]) => void;
  onDownloadTemplate: () => void;
}

const Uploader = ({ onParsed, onDownloadTemplate }: IProps) => {
  const onChange = async (info: UploadChangeParam<any>) => {
    const { file } = info;
    const content = (await file?.text()) || '';
    if (file.type !== 'text/csv') {
      notification.warning({ message: 'Only accept CSV file' });
      return;
    }

    const { data = [] } = Papa.parse<string[]>(content);
    const titleRows: string[] = data[0];
    const results: IGpsPenaltyImport[] = [];
    data.forEach((cells, index) => {
      if (index > 0) {
        const item: any = {};
        cells.forEach((value, rowIndex) => {
          const key = titleRows[rowIndex];
          item[key as keyof IGpsPenaltyImport] = value as never;
        });

        const hasData = cells.some(value => !!value);
        if (hasData) {
          results.push(item);
        }
      }
    });

    onParsed(results);
  };

  return (
    <>
      <Dragger
        name="file"
        multiple={false}
        accept={'text/csv'}
        onChange={onChange}
        showUploadList={false}
        beforeUpload={() => false}
        maxCount={1}
      >
        <Text type="secondary">
          <Import size={14} style={{ fontSize: '40px' }} />
        </Text>
        <div className="my-3"></div>
        <Text type="secondary">
          Click or drag file to this area to upload CSV
        </Text>
      </Dragger>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
        }}
      >
        <Button
          type="primary"
          onClick={onDownloadTemplate}
          icon={<Download size={14} />}
        >
          Download template
        </Button>
      </div>
    </>
  );
};

export default Uploader;
